"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.error.fetch': 'Impossibile caricare i log DB.',
};
